export const storeProduct = [
	{
		_id: 11,
		count: 1,
		product: "Allstar",
		image: "./image/Allstar.jpg",
		price: 7000,
	},
	{
		_id: 12,
		count: 1,
		product: "Fila Sneaker",
		image: "./image/Fila Sneakers.jpg",
		price: 10500,
	},
	{
		_id: 13,
		count: 1,
		product: "Louis vuitton Airforce",
		image: "./image/Louis vuitton Airforce.jpg",
		price: 16000,
	},
	{
		_id: 14,
		count: 1,
		product: "Dark Allstar",
		image: "./image/Dark Allstar .jpg",
		price: 13500,
	},
	{
		_id: 15,
		count: 1,
		product: "Nike Airforce royal",
		image: "./image/Nike Airforce royal.jpg",
		price: 14000,
	},
	{
		_id: 16,
		count: 1,
		product: "Timbaland",
		image: "./image/Timbaland.jpg",
		price: 11000,
	},
	{
		_id: 17,
		count: 1,
		product: "Converse Allstar",
		image: "./image/converse allstar.jpg",
		price: 7500,
	},
	{
		_id: 18,
		count: 1,
		product: "Nike Airforce2 blue",
		image: "./image/Nike Airforce2 blue.jpg",
		price: 9500,
	},
	{
		_id: 19,
		count: 1,
		product: "Nike Air brown",
		image: "./image/Nike Air brown.jpg",
		price: 5000,
	},
	{
		_id: 20,
		count: 1,
		product: "Nike Airforce2",
		image: "./image/Nike Airforce2.jpg",
		price: 4999,
	},
	{
		_id: 21,
		count: 1,
		product: "Nike airmax",
		image: "./image/Nike airmax.jpg",
		price: 3500,
	},
	{
		_id: 22,
		count: 1,
		product: "Vans Reloaded",
		image: "./image/Vans Reloaded.jpg",
		price: 12000,
	},
	{
		_id: 23,
		count: 1,
		product: "christian dior gown",
		image: "./image/ladiesWear/christian dior gown.jpg",
		price: 11500,
	},
	{
		_id: 24,
		count: 1,
		product: "Gucci red gown",
		image: "./image/ladiesWear/Gucci red gown.jpg",
		price: 10999,
	},
	{
		_id: 25,
		count: 1,
		product: "redblack-charlie gown",
		image: "./image/ladiesWear/redcharlie-gown.jpg",
		price: 15500,
	},
]